export const FolderSortRepository = Symbol('FolderSortRepository');
